import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Box, useTheme } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Text from "../../../../theme/text/Text";
import { setPrimaryFilter } from "../../../../../newapi/global/filter/reportFilterSlice";
import { tokens } from "../../../../../theme";
import { reportFilterDataSource } from '../../chartFilterEnums';
import { useEffect, useState } from 'react';
import { useReportHubFilters } from '../../ReportHubFilterContext';
import { DropdownBaseV2 } from '../../../../theme/dropdowns/Dropdown';
import ShSwitch from '../../../../theme/inputs/ShSwitch';

export const RhCategoryBoolean = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();

    // resolve filter function
    const filter = filtersRegistry.filters[props.fKey];
    const resolvedFilter = typeof filter === "function" ? filter() : filter;

    // current boolean value
    const value = !!props.category?.values;

    return (
        <Box
            className={cx(undefined, {
                'from-view':props.fromView,
            })}
            // key={"rp"+idx}
            
            onClick={() => {

                props.setCurrentReport((prev) => ({
                    ...prev,
                    category:{
                        ...prev?.category,
                        values: [!value[0]],
                    },
                }));
            }}
            sx={{
                px:2,
                pr:0.5,
                height:32,
                borderRadius:4,
                display:"flex",
                alignItems:'center',
                cursor:"pointer",
                background:theme.palette.mode === "dark" ? colors.grey[400] : "#E9EFFE",
                "&:hover .rp-value-container" : {
                    pr:4,
                },
                "&:hover .rp-value-container .rp-filter-icon" : {
                    zIndex:1,
                    opacity:1,
                        transition:"125ms",
                },

                '&.from-view' : {
                    height:24,
                }
            }}
        >
            <ShSwitch
                checked={value[0]}
                onClick={(e) => e.stopPropagation()} // prevent row toggle
                onChange={(e) => {
                    const checked = e.target.checked;
                    props.setCurrentReport((prev) => ({
                        ...prev,
                        category:{
                            ...prev?.category,
                            values: [checked],
                        },
                    }));
                }}
                
                sx={{
                    transform: "scale(0.8)",
                }}
            />
            {/* {props.category?.values?.length > 0 ?
                <>
                    <Text noBreak bold>{props.category?.values?.length}</Text>
                    <Text noBreak light sx={{ml:0.5,}}>
                        {t("selected")}
                    </Text>
                </>
            :
                <Text noBreak>{t("no_selection")}</Text>
            } */}
        </Box>
    )
}